type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T

const truthy = <T>(value: T): value is Truthy<T> => !!value

const compact = <T>(array: (T | false | 0 | '' | null | undefined)[]): T[] => {
  return array.filter(truthy)
}

export default compact
